import { ChangeEvent, forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { InputMask } from 'imask';
import { PhonePatternMaskProps } from '../FormPhoneField.types';

export const PhonePatternMask = forwardRef<HTMLInputElement, PhonePatternMaskProps>(({ onChange, isMasked, ...props }, ref) => {
    /**
     * This handles the callback to our input element onChange.
     * We have to construct a psuedo change event manually to pass it to the
     * input element onChange.
     */
    const handleAccept = (value: string, masked: InputMask, el: InputEvent | undefined) => {
        if (onChange) {
            const syntheticEvent = {
                ...el,
                target: {
                    ...el,
                    value: masked.unmaskedValue,
                    selectionEnd: masked._selection.end,
                },
            } as ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

            onChange(syntheticEvent);
        }
    };

    return (
        <IMaskInput
            {...props}
            mask={isMasked ? '(***) ***-0000' : '(#00) 000-0000'}
            definitions={
                isMasked ? {
                    '*': {
                        mask: '0',
                        displayChar: '*',
                        placeholderChar: '',
                    },
                } : {
                    '#': /[1-9]/,
                }
            }
            inputRef={ref}
            onAccept={handleAccept}
        />
    );
});